export default "__VITE_ASSET__DSPIjql7__"